import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '@core/services';

@Injectable()
export class AuthGuard {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isLoggedIn) {
      if (
        this.authService.user.isPlayer &&
        !this.authService.user.isProfileCompleted &&
        state.url !== '/onboard'
      ) {
        this.router.navigate(['/onboard']);

        return false;
      }

      return true;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['login', state.url]);
    return false;
  }
}
